<script setup>
/*
    VuInputGroup.js - Vue input directive

    <vu-input-group v-model="value" schema="schema" fields="Array | string">

    Copyright (c) Embedthis. All Rights Reserved.
*/
import VuInput from '@/paks/vu-input'
import VuValidate from '@/paks/vu-validate'
import {reactive, watch} from 'vue'

const props = defineProps({
    fields: [Array, String],
    labels: Object,
    rules: {type: String, default: () => VuValidate.Rules},
    schema: Object,
    modelValue: [Array, Boolean, Date, Number, Object, String],
})

const page = reactive({
    items: [],
    itemRules: {},
})

watch(() => props.modelValue, makeRules, {deep: true})
watch(() => props.fields, setup, {immediate: true, deep: true})
watch(() => props.schema, setup)

function setup() {
    if (Array.isArray(props.fields)) {
        page.items = props.fields.slice(0)
    } else if (props.fields) {
        let fields = props.fields
        if (typeof fields == 'string') {
            fields = fields.split(',').map((s) => s.trim())
        }
        let list = []
        for (let name of fields) {
            let def = props.schema[name]
            if (def) {
                list.push({
                    name: name,
                    dataType: def.type,
                    type: def.display,
                })
            }
        }
        page.items = list
    } else if (props.schema) {
        let list = []
        for (let name of Object.keys(props.schema)) {
            if (name != 'id') {
                list.push({name})
            }
        }
        page.items = list
    }
    if (props.schema) {
        for (let [name, def] of Object.entries(props.schema)) {
            if (name != 'id') {
                let field = page.items.find((i) => i.name == name)
                if (field) {
                    field.dataType = def.type
                    field.type = def.display
                }
            }
        }
    }
    if (props.labels) {
        for (let [name, title] of Object.entries(props.labels)) {
            let field = page.items.find((i) => i.name == name)
            if (field) {
                field.label = title
            }
        }
    }
    page.items = page.items.filter((i) => !i.disabled)
    makeRules()
}

function makeRules() {
    let allRules = {}
    for (let item of page.items) {
        let rules
        if (item.disabled) {
            rules = []
        } else if (item.required == false && (props.modelValue[item.name] == null || props.modelValue[item.name] == '')) {
            rules = []
        } else if (props.rules) {
            rules = props.rules[item.rule || item.name] || []
        }
        allRules[item.name] = rules
    }
    if (JSON.stringify(allRules) != JSON.stringify(page.itemRules)) {
        page.itemRules = allRules
    }
}
</script>

<template>
    <div class="vu-input-group">
        <vu-input
            v-for="item in page.items"
            :key="item.name"
            v-model="modelValue[item.name]"
            :dataType="item.dataType"
            :name="item.name"
            :label="item.label"
            :disabled="item.disabled"
            :rules="page.itemRules[item.name]" />
    </div>
</template>

<style lang="scss" scoped>
</style>
